const Variables = {
	SidebarWidth: 240
}

export default Variables;
